<template>
    <el-dialog
      :visible.sync="dialogVisible"
      :width="dialogWidth"

      :before-close="handleClose"
      :modal-append-to-body='false'
  >
      <div style="width: 100%;margin: 0px auto;">
          <iframe class="iframeHeight"
            width="100%"
            :src="data.fileUrl || data.linkPath"
            frameborder=0
            allowfullscreen>
          </iframe>
      </div>
  </el-dialog>
</template>
<script>
export default {
    data(){
        return{
            dialogVisible: false,
            data: {},
            dialogWidth:'60%',
        }
    },
    methods:{
        open(data) {
          this.data = data;
          this.dialogVisible = true;
        },
        handleClose() {
          this.data = {}
          this.dialogVisible = false;
        }
    },
    mounted() {
      let screenWidth = document.documentElement.clientWidth;
      if (screenWidth <=768) {
          this.dialogWidth = '80%';

      } else {
          this.dialogWidth = '60%';
      }
    },
}
</script>
<style lang="less" scoped>
    /deep/.el-dialog__wrapper{
        position: absolute !important;
    }
    /deep/.v-modal{
        position: absolute !important;

    }
    /deep/.el-dialog{
        background: none;
    }
    /deep/.el-dialog__headerbtn .el-dialog__close{
        color: #fff;
        font-size: 30px;
    }
    /deep/.el-carousel__arrow{
        background-color: rgba(255,255,255,.5);
    }
    .iframeHeight{
        min-height: 250px;
        height: auto;
    }
    @media (min-width: 768px){
        .iframeHeight{
            min-height: 450px;
            height: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/components/videoDialog.vue